import "./mortar.scss";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from "react-helmet";


export default function Mortar() {
    const img = [
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731588638/mortar2_dv0ccv.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731588638/mortar1_b7hvil.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731588638/mortar2_dv0ccv.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731588638/mortar1_b7hvil.jpg"
    ]
    const [currentImg, setCurrentImg] = useState(0)
  return (

    <div className='main_wrapper'>
        <Helmet>
        <title>Refractory Mortar || Raydron, Lagos, Nigeria</title>
        <meta name="description" content="Our Refractory mortar is a specially formulated mortar designed to withstand high temperatures and is commonly used for bonding or setting fire bricks in high-heat applications such as fireplaces, wood-burning stoves, fire pits, furnaces, and kilns. "/>
        <meta name="keywords" content="fire brick mortar, fire brick cement, refractory mortar, Lagos Nigeria" />
    </Helmet>
        <h3>Fire Brick Mortar/Cement</h3>
        <div className='product_wrapper'>
            <div className="image_column">
                <div className="main_image">
                    <img className = 'imgMain' src={img[currentImg]} alt="product_image" />
                </div>
                <div className="slider_image_row">
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[0]} alt="product_image" onClick={(e)=>(setCurrentImg(0))}/>
                    </div>    
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[1]} alt="product_image" onClick={(e)=>(setCurrentImg(1))}/>
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[2]} alt="product_image"  onClick={(e)=>(setCurrentImg(2))} />
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[3]} alt="product_image"  onClick={(e)=>(setCurrentImg(3))} />
                    </div>
                </div>

            </div>
            <div className="description">
                <p className='text'>
                Key Characteristics of Our  Refractory Mortar:
                </p>
                <ul>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Can withstand up to  1,800°C. 
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>High Bond Strength
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Air-Setting Mortar
                    </li>
                </ul>
                <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAP">Chat Us to Buy</button></a>
            </div>
        </div>
        <div className="details">
        Refractory mortar is a specially formulated mortar designed to withstand high temperatures and is commonly used for bonding or setting fire bricks in high-heat applications such as fireplaces, wood-burning stoves, fire pits, furnaces, and kilns. Unlike traditional mortar, which can crack or disintegrate under intense heat, refractory mortar maintains its integrity and adheres well to refractory materials, offering both heat resistance and durability.
                </div>
    </div>
  )
}
